import React, { useEffect, useState } from "react";
import { PlayCircle } from "lucide-react";
import { Card } from "../components/ui/card";
import { Header } from "../components/ui/header";
import { Footer } from "../components/ui/footer";
import axios from "axios";
import { money } from "../utilities/currency";
import EventDetailPage from "./EventDetailPage.tsx";
import { useSelector } from 'react-redux';
import { RootState } from "../state/store.ts";
import Events from "../components/events.tsx";
type EventsPageProps = {
    currentUser: any,
    onLogout: any,
    baseUrl: string,
    onLoginClick: any,
    onLoginSuccess: any,
}
const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};
export default function EventsPage({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess }: EventsPageProps) {
    const [selectedEvent, setSelectedEvent] = useState(null);
    
    const [wallet, setWallet] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])

    const onBack = () => {
        setSelectedEvent(null);
    }

    // DETAIL VIEW
    if (selectedEvent) {
        return <EventDetailPage event={selectedEvent} onBack={onBack} />;
        // return (
        //     <div className="w-full min-h-screen bg-gradient-to-b from-white to-slate-50 py-12 px-6 animate-fadeIn">
        //         <button
        //             onClick={() => setSelectedEvent(null)}
        //             className="mb-6 text-blue-600 hover:text-blue-800 text-sm font-medium"
        //         >
        //             ← Tilbake
        //         </button>

        //         <div className="max-w-4xl mx-auto bg-white/80 backdrop-blur-xl shadow-xl rounded-3xl overflow-hidden border border-white/20">
        //             <div className="relative h-72 w-full">
        //                 <img
        //                     src={selectedEvent.image}
        //                     className="w-full h-full object-cover"
        //                 />
        //                 <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
        //                 {selectedEvent.live && (
        //                     <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md animate-pulse">
        //                         LIVE
        //                     </div>
        //                 )}
        //                 <h1 className="absolute bottom-4 left-6 text-3xl font-bold text-white drop-shadow-lg">
        //                     {selectedEvent.title}
        //                 </h1>
        //             </div>

        //             <div className="p-8">
        //                 <p className="text-slate-700 mb-6 text-lg">
        //                     {selectedEvent.description}
        //                 </p>

        //                 <div className="flex items-center gap-4 mb-8">
        //                     <img
        //                         src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=200&q=80"
        //                         className="w-16 h-16 rounded-full object-cover"
        //                     />
        //                     <div>
        //                         <p className="font-semibold text-slate-900">
        //                             Veronica Hansen
        //                         </p>
        //                         <p className="text-sm text-slate-600">
        //                             Sertifisert veileder og kursansvarlig
        //                         </p>
        //                     </div>
        //                 </div>

        //                 <div className="flex justify-between items-center">
        //                     <span className="text-xl font-semibold text-purple-700">
        //                         {selectedEvent.price === 0
        //                             ? "Gratis"
        //                             : `${selectedEvent.price} kr`}
        //                     </span>
        //                     <button className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-purple-600 text-white font-medium hover:bg-purple-700 transition">
        //                         <PlayCircle className="w-5 h-5" />
        //                         {selectedEvent.price === 0 ? "Delta gratis" : "Kjøp tilgang"}
        //                     </button>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // );
    }

    // LIST / GRID VIEW
    return (
        <div className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} />
            <Events currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} onLoginClick={onLoginClick} onLoginSuccess={onLoginSuccess} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} />
            <Footer baseUrl={baseUrl} />
        </div>
    );
}
